import { render } from "./video.vue?vue&type=template&id=a85ea05c&scoped=true"
import script from "./video.vue?vue&type=script&setup=true&lang=js"
export * from "./video.vue?vue&type=script&setup=true&lang=js"

import "./video.vue?vue&type=style&index=0&id=a85ea05c&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85ea05c"],['__file',"resources/js/components/whatsapp-managment/includes/types/video.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a85ea05c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a85ea05c', __exports__)) {
    console.log('reload')
    api.reload('a85ea05c', __exports__)
  }
  
  module.hot.accept("./video.vue?vue&type=template&id=a85ea05c&scoped=true", () => {
    console.log('re-render')
    api.rerender('a85ea05c', render)
  })

}


export default __exports__